import i18n from '../i18n';

// Visibility → display chip metadata, shared by every surface that renders a
// private/friends/public indicator (UnifiedCard album section, the planner's
// Memories, album detail header). "Only you" / "Friends" / "Everyone"
// (Kurtis, 2026-10-13). Icons match the SharingModal picker so the chip and
// the modal read as the same control.
export const VISIBILITY_CHIPS = {
  private: { icon: 'lock', get label() { return i18n.t('labels:visibilityChips.private'); } },
  friends: { icon: 'userGroup', get label() { return i18n.t('labels:visibilityChips.friends'); } },
  public: { icon: 'globe', get label() { return i18n.t('labels:visibilityChips.public'); } }
};
